import React from 'react';
import { Icon } from '@innovationnorway/cl-react';

const AdvisorButton = ({
  dropdownId,
  initials,
  colorClass,
  label,
  onClick,
}: {
  dropdownId: string;
  initials: string | undefined;
  colorClass: string;
  label: string;
  onClick?: () => void;
}) => (
  <button
    data-size="sm"
    popovertarget={dropdownId}
    onClick={onClick}
    aria-label={label}
    className={`action-button--container ${colorClass} ${initials ? 'no-border' : ''}`}
  >
    {initials ? (
      <span className="color--white">{initials}</span>
    ) : (
      <Icon iconName="user-plus" prefix="fasr" />
    )}
  </button>
);

export default AdvisorButton;
